import { Slider } from "./Slider";
export function InshaFeatures() {
  return <Slider />;
}
